import {
	FocusEvent,
	forwardRef,
	MouseEvent,
	useCallback,
	useState,
} from 'react';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';

import { MplInputV2 } from '../../atoms/MplInputV2';
import { VisibilityOffIcon } from '../../icons/VisibilityOff';
import { VisibilityOnIcon } from '../../icons/VisibilityOn';

export const PasswordInput = forwardRef<HTMLInputElement, TextFieldProps>(
	(props, ref) => {
		const [showing, setShowing] = useState(false);
		const [isFocused, setIsFocused] = useState(false);
		const { onFocus, onBlur } = props;

		const handleClickShowPassword = (event: MouseEvent<HTMLButtonElement>) => {
			event.preventDefault();
			event.stopPropagation();
			setShowing(!showing);
		};

		const handleFocus = useCallback(
			(e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setIsFocused(true);
				onFocus?.(e);
			},
			[onFocus]
		);

		const handleBlur = useCallback(
			(e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setIsFocused(false);
				onBlur?.(e);
			},
			[onBlur]
		);

		return (
			<MplInputV2
				{...props}
				onFocus={handleFocus}
				onBlur={handleBlur}
				ref={ref}
				type={showing ? 'text' : 'password'}
				variant="outlined"
				InputProps={{
					endAdornment: isFocused && (
						<InputAdornment position="end">
							<IconButton
								data-testid="PasswordInput-togglePasswordVisibility-button"
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								tabIndex={-1}
								onMouseDown={(e) => {
									e.preventDefault();
								}}
								edge="end"
							>
								{showing ? <VisibilityOffIcon /> : <VisibilityOnIcon />}
							</IconButton>
						</InputAdornment>
					),
				}}
			/>
		);
	}
);

PasswordInput.displayName = 'PasswordInput';
